document.addEventListener("DOMContentLoaded", function () {
    const videoElement = document.querySelector("#MainContent video#my-lecturess");
    if (videoElement) {
        const player = new Plyr(videoElement);
    }
});


document.addEventListener('DOMContentLoaded', function(){
  var a = $(".lectures-container").find(".lectures-encrypted").attr('links');
  $(".lecture-actual-video-container source").attr('src',a);
}); 
$(".lectures-container").on("click", function(){
  var a = $(this).find(".lectures-encrypted").attr('links');
  $(".lecture-actual-video-container source").attr('src',a);
  document.getElementById('my-lecturess').load();
})

function updateCourseInfo(container) {
  const lectureDurations = container.querySelectorAll('.lecture-length');
  const totalEpisodesElement = container.querySelector('.total-episodes');
  const totalTimeElement = container.querySelector('.total-time');

  let totalSeconds = 0;
  let totalEpisodes = lectureDurations.length;

  lectureDurations.forEach(duration => {
    const text = duration.textContent.trim();
    let hours = 0, minutes = 0, seconds = 0;

    const hoursMatch = text.match(/(\d+)\s*hr/);
    const minutesMatch = text.match(/(\d+)\s*min/);
    const secondsMatch = text.match(/(\d+)\s*sec/);

    if (hoursMatch) {
      hours = parseInt(hoursMatch[1], 10);
    }
    if (minutesMatch) {
      minutes = parseInt(minutesMatch[1], 10);
    }
    if (secondsMatch) {
      seconds = parseInt(secondsMatch[1], 10);
    }

    totalSeconds += (hours * 3600) + (minutes * 60) + seconds;
  });

  const totalHours = Math.floor(totalSeconds / 3600);
  const remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  totalEpisodesElement.textContent = `${totalEpisodes} Lectures`;
  totalTimeElement.textContent = `${totalHours}h ${remainingMinutes}m ${remainingSeconds}s`;
}


document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.p-lectures-information--container');
  containers.forEach(container => {
    updateCourseInfo(container);
  });
});



  $(document).ready(function () {
    $('#product-add-to-cart').click(function () {
      const productId = $(this).attr('variant');
      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        dataType: 'json',
        data: {
          id: productId,
          quantity: 1,
        },
        success: function (response) {
         window.location.href = "/cart";
        }
      });
    });
  });

document.addEventListener("DOMContentLoaded", function () {
  const description = document.getElementById("productDescription");
  const toggleButton = document.getElementById("toggleButton");

  toggleButton.addEventListener("click", function () {
    if (description.classList.contains("expanded")) {
      description.classList.remove("expanded");
      toggleButton.textContent = "Show More";
    } else {
      description.classList.add("expanded");
      toggleButton.textContent = "Show Less";
    }
  });
});